export default __webpack_public_path__ + "static/media/prints.908ad41d.svg";